import api from "./axios";

// Create a new followup task
export const createFollowupTaskApi = (data) =>
  api.post("/followup-tasks", data);

// Get all followup tasks with optional filters
export const getFollowupTasksApi = (params) =>
  api.get("/followup-tasks", { params });

// Get a single followup task by ID
export const getFollowupTaskByIdApi = (id) => api.get(`/followup-tasks/${id}`);

// Update a followup task
export const updateFollowupTaskApi = (id, data) =>
  api.put(`/followup-tasks/${id}`, data);

// Delete a followup task
export const deleteFollowupTaskApi = (id) =>
  api.delete(`/followup-tasks/${id}`);

// Search leads for autocomplete
export const searchLeadsApi = (query) =>
  api.get("/followup-tasks/search-leads", { params: { query } });
